(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["instagram-kupon-popup"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('.rz-ig');
  if(!root||root.dataset.ready==='1')return;
  root.dataset.ready='1';

  var design=root.dataset.design==='true';
  var closeButtons=root.querySelectorAll('[data-rz-ig-close]');
  var reveal=root.querySelector('[data-rz-ig-reveal]');
  var coupon=root.querySelector('[data-rz-ig-coupon]');
  var copy=root.querySelector('[data-rz-ig-copy]');
  var code=root.querySelector('[data-rz-ig-code]');
  var afterCloseSeconds=Math.max(5,Number(root.dataset.delay)||60);
  var storageKey='renazzoInstagram50LastShown';
  var legacySessionKey='renazzoInstagram50Closed';
  var sevenDaysMs=7*24*60*60*1000;
  var instagramClosed=false;
  var showTimer=null;

  function readLastShown(){
    try{
      var value=Number(localStorage.getItem(storageKey)||0);
      return isFinite(value)&&value>0?value:0;
    }catch(e){
      return 0;
    }
  }
  function markShown(){
    if(design)return;
    var now=Date.now();
    try{localStorage.setItem(storageKey,String(now))}catch(e){}
    try{sessionStorage.setItem(legacySessionKey,'1')}catch(e){}
  }
  function hide(){
    root.hidden=true;
    instagramClosed=true;
  }
  function show(){
    if(instagramClosed)return;
    if(primary&&!primary.hasAttribute('hidden'))return;
    root.hidden=false;
    markShown();
  }
  function scheduleShow(){
    if(showTimer||instagramClosed)return;
    var remaining=Math.max(0,afterCloseSeconds*1000-performance.now());
    showTimer=setTimeout(function(){showTimer=null;show()},remaining);
  }

  for(var i=0;i<closeButtons.length;i++)closeButtons[i].addEventListener('click',hide);
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!root.hidden)hide()});
  if(reveal)reveal.addEventListener('click',function(){coupon.hidden=false});
  if(copy)copy.addEventListener('click',function(){
    var t=code?code.textContent.trim():'';
    if(!t)return;
    var done=function(){copy.textContent='Kopyalandı';setTimeout(function(){copy.textContent='Kopyala'},1600)};
    if(navigator.clipboard&&navigator.clipboard.writeText)navigator.clipboard.writeText(t).then(done);
  });

  if(design){show();return;}

  var lastShown=readLastShown();
  if(lastShown&&Date.now()-lastShown<sevenDaysMs){
    instagramClosed=true;
    return;
  }

  /* Eski oturum bazlı kaydı 7 günlük kalıcı kurala taşı. */
  try{
    if(!lastShown&&sessionStorage.getItem(legacySessionKey)==='1'){
      markShown();
      instagramClosed=true;
      return;
    }
  }catch(e){}

  /*
   * Sıralama kuralı:
   * Sayfa açılışından itibaren ayarlanan süreyi bekler.
   * İlk popup açıksa onun kapanmasını bekler.
   */
  var primary=document.querySelector('subscription-popup.subscription-popup');
  if(!primary){
    scheduleShow();
    return;
  }

  var primaryWasOpen=!primary.hasAttribute('hidden');
  var observer=new MutationObserver(function(mutations){
    for(var j=0;j<mutations.length;j++){
      if(mutations[j].type!=='attributes'||mutations[j].attributeName!=='hidden')continue;
      if(!primary.hasAttribute('hidden')){
        primaryWasOpen=true;
        root.hidden=true;
        if(showTimer){clearTimeout(showTimer);showTimer=null;}
      }else if(primaryWasOpen){
        observer.disconnect();
        scheduleShow();
      }
    }
  });
  observer.observe(primary,{attributes:true,attributeFilter:['hidden']});

  scheduleShow();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renazzo-campaign-popup"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.querySelector('.rz-campaign');
  if(!root||root.dataset.ready==='1')return;
  root.dataset.ready='1';
  var design=root.dataset.design==='true';
  var delay=Math.max(0,Number(root.dataset.delay)||30);
  var repeatMinutes=Math.max(1,Number(root.dataset.repeatMinutes)||30);
  var repeatMs=repeatMinutes*60*1000;
  var storageKey='renazzoFirsatGunleriLastShown';
  var closeButtons=root.querySelectorAll('[data-rz-campaign-close]');
  var closeButton=root.querySelector('.rz-campaign__close');
  var confettiRoot=root.querySelector('[data-rz-campaign-confetti]');
  var timer=null;

  function readLastShown(){
    try{var value=Number(localStorage.getItem(storageKey)||0);return isFinite(value)&&value>0?value:0}catch(e){return 0}
  }
  function markShown(){if(design)return;try{localStorage.setItem(storageKey,String(Date.now()))}catch(e){}}
  function makeConfetti(){
    if(!confettiRoot||window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    confettiRoot.innerHTML='';
    var colors=['#0b3156','#123f68','#c99a42','#e0b763','#f1d28c'];
    for(var i=0;i<22;i++){
      var p=document.createElement('i');
      p.style.setProperty('--x',(4+Math.random()*92)+'%');
      p.style.setProperty('--drift',(-90+Math.random()*180)+'px');
      p.style.setProperty('--rot',(360+Math.random()*720)+'deg');
      p.style.setProperty('--delay',(Math.random()*.55)+'s');
      p.style.setProperty('--dur',(1.9+Math.random()*1.15)+'s');
      p.style.setProperty('--w',(5+Math.random()*5)+'px');
      p.style.setProperty('--h',(9+Math.random()*10)+'px');
      p.style.setProperty('--c',colors[Math.floor(Math.random()*colors.length)]);
      confettiRoot.appendChild(p);
    }
  }
  function hide(){root.hidden=true}
  function show(){root.hidden=false;markShown();makeConfetti();setTimeout(function(){try{closeButton.focus({preventScroll:true})}catch(e){}},50)}

  for(var i=0;i<closeButtons.length;i++)closeButtons[i].addEventListener('click',hide);
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!root.hidden)hide()});

  if(design){setTimeout(show,100);return}
  var lastShown=readLastShown();
  if(lastShown&&Date.now()-lastShown<repeatMs)return;
  timer=setTimeout(show,delay*1000);
})();

  } catch(e) { console.error(e); }
})();
})();
